import moment from 'moment';
import { ACCOUNT_STATUS } from '../../enums/AccountStatus';
import { UserType } from '../../enums/UserType';

/**
 * The account standings an admin can set on a user or filter a user list by,
 * in display order. The profile status dropdown and the list status filters
 * are both built from this list, so a new standing is added here once.
 */
export const ACCOUNT_STANDING_OPTIONS = [
  { code: ACCOUNT_STATUS.VERIFIED, name: 'Verified' },
  { code: ACCOUNT_STATUS.RESTRICTED, name: 'Restricted' },
  // Only offices are charged, so only offices can be payment-restricted.
  { code: ACCOUNT_STATUS.RESTRICTED_PAYMENTS, name: 'Restricted - Payments', officeOnly: true },
  { code: ACCOUNT_STATUS.PAUSED, name: 'Paused' },
  { code: ACCOUNT_STATUS.IN_REVIEW, name: 'In Review' },
  { code: ACCOUNT_STATUS.BLOCKED, name: 'Blocked' },
];

export const getAccountStandingOptions = (userType) =>
  ACCOUNT_STANDING_OPTIONS.filter((option) => !option.officeOnly || userType === UserType.DNT);

export const NO_RESTRICTIONS_LABEL = 'No Restrictions';
export const PAYMENT_RESTRICTION_LABEL =
  'Restricted - Payments (failed charge, lifts when a new default payment method is selected)';

export const getRestrictionLabel = (accountStanding, restrictionDate) => {
  if (accountStanding === ACCOUNT_STATUS.RESTRICTED_PAYMENTS) {
    return PAYMENT_RESTRICTION_LABEL;
  }
  if (accountStanding === ACCOUNT_STATUS.RESTRICTED && restrictionDate) {
    return `Restricted until ${moment(restrictionDate).format('ddd, MMMM Do, YYYY')}`;
  }
  return NO_RESTRICTIONS_LABEL;
};
